var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tabs',{staticClass:"dynamic-tabs-container",style:({
        width: '100%',
        height: '100%'
    }),attrs:{"type":"border-card"},model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},_vm._l((Object.keys(_vm.options.fields)),function(tabName,tabIndex){return _c('el-tab-pane',{key:tabIndex,attrs:{"name":tabName,"label":_vm.getTabPaneLabel(_vm.options.fields[tabName]),"disabled":!_vm.isPreview && _vm.$route.params.routeParams && !_vm.$routerParamsDecrypt(_vm.$route.params.routeParams).companyId}},[(tabName === _vm.activeTab)?_c('dynamic-form',{ref:_vm.dynamicFormRef,refInFor:true,attrs:{"options":_vm.options.fields[tabName].fields,"parent":{
           type: 'tabs',
           instance: _vm.cInstance
       }}}):_vm._e()],1)}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fc6a6e04","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dynamic/support/Tabs.vue
// module id = null
// module chunks = 